module.exports = __webpack_public_path__ + "static/media/calendar-icon.a36c052a.svg";